import { createContext, PropsWithChildren, useContext } from "react"

import { Psychologist } from "utils/interfaces"

interface ContextValues {
    similar: Psychologist[]
}

const Context = createContext<ContextValues>({ similar: [] })

export function StaticDataProvider({ children, similar }: PropsWithChildren<ContextValues>) {
    return <Context.Provider value={{ similar }}>{children}</Context.Provider>
}

export function useStaticDataContext() {
    return useContext(Context)
}
